
import { defineComponent, PropType } from 'vue'

export type SearchRepoT = {
  id: string
  name: string
  owner: string
}

export default defineComponent({
  name: 'RepoFinder',
  props: {
    value: {
      type: String,
      default: ''
    },
    searchList: {
      type: Array as PropType<SearchRepoT[]>,
      default: () => []
    }
  },
  data() {
    return {
      shown: false
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(value: string) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    handleSubmit(index: number) {
      if (!this.searchList || typeof index !== 'number') return
      if (index < 0 || index >= this.searchList.length) return

      const valueToEmit = this.searchList[index]
      this.$emit('selected', valueToEmit)
      this.shown = false
    },
    handleClickOutside(event: MouseEvent) {
      const root = this.$refs['search-root'] as HTMLElement
      if (root && !root.contains(event.target as Node)) {
        this.shown = false
      }
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }
})
